var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 52,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FBFBFA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.201342 0L0 0.204832V13H4.26846V6.82773H4.74832L8.91275 13V25.7952C8.98993 25.8737 9.03691 25.9215 9.11409 26H12.9799C13.057 25.9215 13.104 25.8737 13.1812 25.7952V13L4.4094 0H0.201342Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7315 19.1723H26.2517L22.0872 13V0.204832L21.8859 0H18.0201L17.8188 0.204832V13L26.5872 26H30.7953L30.9966 25.7952V13H26.7282V19.1723H26.7315Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8be40dea70e187a5e92dc26fbde421b3.svg";
export { ForwardRef as ReactComponent };